import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import global from './components/Global.vue'
import ElementUI from 'element-ui'
import { Message } from 'element-ui'
import BaiduMap from 'vue-baidu-map'
import jsCookie from 'js-cookie'
import VueCropper from 'vue-cropper'
import 'echarts'
import ECharts from 'vue-echarts'
import 'element-ui/lib/theme-chalk/index.css';


axios.defaults.baseURL ='http://zhsq.chenyingwei.com/api'
axios.interceptors.request.use(
  function(config) {
    startLoading()
    // 设置统一的请求头
    if(sessionStorage.getItem('token')){
      config.headers.Authorization = sessionStorage.getItem('token')
    }
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    endLoading()
    if (response.status === 400) {
      router.replace('/');
      console.log("token过期");
    }
    return response;
  },
  error => {
    endLoading()
    if(error.request.status==401){
      router.push('/');
    }else if(error.request.status==500){
      console.log(ElementUI)
      Message({
        message: "未知错误",
        type: 'error'
      });
    }
    return Promise.reject(error);
  }
);

Vue.component('ECharts',ECharts)
Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.$cookie = jsCookie
Vue.prototype.global = global
Vue.use(ElementUI);
Vue.use(VueCropper)
Vue.use(BaiduMap, {
  ak:'9a76a6f405d191d7a5382cf9c657b57e'
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

let loading;
function startLoading() {	
  loading = ElementUI.Loading.service({
    lock: true,
    text: "加载中...",
    background: 'rgba(0,0,0,0.2)'
  })
}

function endLoading() {
  loading.close()
}
